import React from 'react';
import {Modal} from '@forecast-it/design-system';
import {FormattedMessage} from 'react-intl';

type RemoveDeliverableFromPhaseModalProps = {
	closeModal: () => void;
	callback: () => void;
};

const RemoveDeliverableFromPhaseModal = ({closeModal, callback}: RemoveDeliverableFromPhaseModalProps): React.JSX.Element => {
	const onClickConfirm = () => {
		callback();
		closeModal();
	};

	return (
		<Modal size={Modal.SIZE.SMALL} onCloseModal={closeModal}>
			<Modal.Title>
				<FormattedMessage id={'deliverable.remove_deliverable_from_phase'} />
			</Modal.Title>
			<Modal.Content>
				<FormattedMessage id={'deliverable.remove_deliverable_from_phase.description'} />
			</Modal.Content>
			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={onClickConfirm} dataCy={'modal-btn-confirm'}>
					<FormattedMessage id="common.confirm" />
				</Modal.PrimaryFooterButton>
				<Modal.SecondaryFooterButton onPress={closeModal}>
					<FormattedMessage id="common.go_back" />
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default RemoveDeliverableFromPhaseModal;
